import React, { useState, useEffect, useContext } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  MenuItem,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";
import { Form, Formik } from "formik";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

// User Import

import {
  BATCH_MAIN_TYPES_ENUM_ARRAY,
  USER_ROLES_ENUM,
  BATCH_CREATE_ENUMS,
  BATCH_SUB_TYPES_ENUM_ARRAY,
  RequestEnumArr,
  TEMPRATURE_TYPES_ENUM_ARRAY,
  TEMPRATURE_ENUM_ARRAY,
} from "../../../../common/Enums";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { headersPost } from "../../../../Services/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { CustomDateInput } from "../../../../common/Components";
import { ministry_Context } from "../../../../context";
import { receiveInventorySchema } from "../../../../Services/validations/MinistryPortal/Batch";

// Constant

const initialValues = {
  main_type: "",
  sub_type: "",
  batch_type: "",
  parent_batch_id: "",
  reference_number: "",
  lot_number: "",
  previous_temperature: "",
  expiry_date: "",
  quantity_received: "",
  quantity_damaged: "",
  //   receiver_name: "",
  //   receiver_id: "",
  note: "",
};

// Component

const ReceiveInventory = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { provinces } = useContext(ministry_Context);

  //states

  const [formValue, setFormValue] = useState(initialValues);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [batchArr, setBatchArr] = useState("");
  const [mainTypeValue, setMainTypeValue] = useState("");
  const [subTypeValue, setSubTypeValue] = useState("");

  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      batch: {
        request_id: state?.request_data?.id,
        expiry_date: values?.expiry_date,
        previous_temperature: values?.previous_temperature,
        quantity_received: values?.quantity_received,
        quantity_damaged: values?.quantity_damaged,
        note: values?.note,
      },
    };

    setOpen(true);

    headersPost(MINISTRY_API_ULRS.RECEIVE_INVENTORY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-2);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getTypeHandler1();
  }, [subTypeValue, mainTypeValue]);

  const getTypeHandler1 = () => {
    if (subTypeValue && mainTypeValue) {
      const data = {
        batch: {
          reference_number: mainTypeValue,
          previous_temperature: subTypeValue,
        },
      };
      setOpen(true);

      headersPost(MINISTRY_API_ULRS.GET_TEMPERATURE, data)
        .then((res) => {
          setOpen(false);
          if (res?.status === 200 && res?.data?.success) {
            setBatchArr(res?.data?.expiry_date);
          } else {
            setAlertOpen(true);
            setAlertMsg(res?.data?.message);
            setAlertIcon("warning");
          }
        })
        .catch((err) => {
          setOpen(false);
          const { response } = err;
          if (response?.status === 401) {
            localStorage.clear();
            navigate(RoutesUrls?.root);
          } else {
            setAlertOpen(true);
            setAlertMsg(response?.statusText);
            setAlertIcon("error");
          }
        });
    } else return;
  };

  useEffect(() => {
    state?.request_data?.id &&
      setFormValue((prev) => ({
        ...prev,
        // parent_batch_id: state?.request_data?.id,
        // size: state?.request_data?.available_quantity,
        main_type: state?.request_data?.main_type,
        sub_type: state?.request_data?.sub_type,
        quantity_received: state?.request_data?.quantity,
        batch_type: state?.request_data?.sender_role,
        reference_number: state?.request_data?.reference_number,
        lot_number: state?.request_data?.lot_number,
        receiver_id: state?.request_data?.sender_id,
        receiver_name: state?.request_data.sender_name,
        expiry_date: state?.request_data?.expiry_date,
      }));
    return () => {
      setFormValue(initialValues);
    };
  }, [state?.request_data]);

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",

        borderRadius: 1,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"left"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Inventory Receival Form
        </Typography>
        <Formik
          initialValues={formValue}
          onSubmit={formSubmitHanlder}
          validationSchema={receiveInventorySchema}
          enableReinitialize
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 0, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                >
                  <Grid container marginBottom={5} spacing={{ xs: 3, sm: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      {(setMainTypeValue(values?.reference_number) && null) ||
                        null}
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        disabled
                        name="reference_number"
                        type={"text"}
                        value={values?.reference_number}
                        error={
                          touched?.reference_number &&
                          Boolean(errors?.reference_number)
                        }
                        helperText={
                          touched?.reference_number && errors?.reference_number
                        }
                        placeholder={"batch#"}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="main_type"
                        value={values.main_type}
                        select
                        disabled
                        error={touched?.main_type && Boolean(errors?.main_type)}
                        helperText={touched?.main_type && errors?.main_type}
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select an inventory type
                        </MenuItem>
                        {BATCH_MAIN_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="sub_type"
                        value={values.sub_type}
                        error={touched?.sub_type && Boolean(errors?.sub_type)}
                        helperText={touched?.sub_type && errors?.sub_type}
                        select
                        disabled
                        fullWidth
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select Category
                        </MenuItem>
                        {BATCH_SUB_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"number"}
                        name="quantity_received"
                        disabled
                        // onChange={handleChange}
                        error={
                          touched?.quantity_received &&
                          Boolean(errors?.quantity_received)
                        }
                        helperText={
                          touched?.quantity_received &&
                          errors?.quantity_received
                        }
                        value={values.quantity_received}
                        placeholder="Enter quantity received"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            // backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"number"}
                        name="quantity_damaged"
                        onChange={handleChange}
                        error={
                          touched?.quantity_damaged &&
                          Boolean(errors?.quantity_damaged)
                        }
                        helperText={
                          touched?.quantity_damaged && errors?.quantity_damaged
                        }
                        value={values.quantity_damaged}
                        placeholder="Enter quantity damaged"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            // backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        disabled
                        name="lot_number"
                        type={"text"}
                        value={values?.lot_number}
                        placeholder={"lot#"}
                        error={
                          touched?.lot_number && Boolean(errors?.lot_number)
                        }
                        helperText={touched?.lot_number && errors?.lot_number}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        select
                        name="previous_temperature"
                        onChange={(date) => {
                          setSubTypeValue(date.target.value);
                          handleChange(date);
                        }}
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        error={
                          touched?.previous_temperature &&
                          Boolean(errors?.previous_temperature)
                        }
                        helperText={
                          touched?.previous_temperature &&
                          errors?.previous_temperature
                        }
                        value={values.previous_temperature}
                        // placeholder="Storage temperate"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Storage Temprature
                        </MenuItem>
                        {TEMPRATURE_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      {(batchArr &&
                        (values.expiry_date = format(
                          new Date(batchArr),
                          "MM/dd/yyyy"
                        )) &&
                        null) ||
                        null}
                      <TextField
                        variant="outlined"
                        size={"small"}
                        placeholder="Expiry date"
                        type={"text"}
                        name="expiry_date"
                        value={values?.expiry_date}
                        onChange={handleChange}
                        disabled
                        error={
                          touched?.expiry_date && Boolean(errors?.expiry_date)
                        }
                        helperText={touched?.expiry_date && errors?.expiry_date}
                        fullWidth
                        sx={{
                          [`.${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        rows={3}
                        type={"text"}
                        name="note"
                        onChange={handleChange}
                        value={values.note}
                        multiline
                        placeholder="Batch Description"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            // backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {/* Button */}
                  <Grid container>
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"right"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: 2,
                          minWidth: "20%",
                        }}
                      >
                        {" "}
                        Done{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        color={alertIcon}
        autoHideDuration={100000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon} color={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default ReceiveInventory;
